// extracted by mini-css-extract-plugin
module.exports = {"form-body":"FormBody_form-body__r7p7V"};